import "./ExperienceRanking.css";

export default function ExperienceRanking(props) {

  const generateBoxes = (amount) => {
    const resultList = [];
    for(let i = 0; i < 5; i++) {
      resultList.push(
        <div
          className="box"
          id={amount > i ? "filled-box" : null}
          key={i}
        >

        </div>
      );
    }
    return resultList;
  }

  return (
    <div
      className="box-container"
    >
      {generateBoxes(props.ranking)}
    </div>
  )
}